import React from "react"

//material-ui
// import Drawer from '@material-ui/core/Drawer';
// import Toolbar from '@mui/material/Toolbar';
// import Divider from '@material-ui/core/Divider';
// import Container from '@material-ui/core/Container';
// import Typography from '@material-ui/core/Typography';
// import Box from '@material-ui/core/Box';
// import TocSharpIcon from '@material-ui/icons/TocSharp';

//MUI v5 移行完了
import { Drawer, Container, Box, Toolbar, Divider, Typography } from '@mui/material'
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import TocSharpIcon from '@mui/icons-material/TocSharp';


//ドロワ
const DrawerComponent = (({ toc_html }) => {

    const theme = useTheme()

    //使わないように変更
    // const isFirstEnter = theme.status?.isFirstEnter

    //右ドロワのサイズ
    const drawerWidthRight = "300px";

    const IconTypoBox = styled(Box)({
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        width: "100%"
    })

    return (
        <Drawer
            anchor="right"
            variant="persistent"
            open={true}
            //ドロワ内部での非表示は使わないように変更。
            // sx={{
            //     width: drawerWidthRight,
            //     flexShrink: 0,
            //     ...(isFirstEnter && {
            //         visibility: "hidden",
            //       }),
            // }}
        >
            <Toolbar />
            <Container sx={{
                overflow: 'auto',
                width: drawerWidthRight,
            }}>
                <IconTypoBox pt={3} mb={1}>

                    <TocSharpIcon sx={{ marginRight: theme.spacing(1) }} />
                    <Typography variant="subtitle1">
                        目次
                    </Typography>

                </IconTypoBox>
                <Divider />
                <Box sx={{
                    //右ドロワのToC用
                    "& ul": {
                        paddingLeft: theme.spacing(2),
                    },
                    "& li": {
                        listStyleType: "decimal",
                        "& li": {
                            listStyleType: "disc",
                        },
                    },
                    "& a": {
                        color: "white",
                        "&:hover": {
                            color: "#64b5f6",
                        },

                    },
                }}
                    dangerouslySetInnerHTML={{ __html: toc_html }}
                />
            </Container>
        </Drawer>
    )
}
);

export default DrawerComponent